import React from 'react';
import SubscriptionSwitcher from 'subscriptions/SubscriptionSwitcher';
import AddDataPicker from 'subscriptions/AddDataPicker/bypassed';
import DataRemaining from 'subscriptions/DataRemaining/bypassed';
import * as routes from 'app/routes';
import styles from './AddData.module.css';
import add_data from 'common/img/add_data.svg';
import Back from 'common/Back';

export const AddDataScreen = ({ subId }) => {
  return (
    <div className={styles.AddData}>
      <SubscriptionSwitcher
        bypassedSubId={subId}
        quickRoute={routes.quickSubscription}
        bypassedRoute={routes.bypassedAddData}
        sprintRoute={routes.sprintAddData}
      />
      <div className={styles.Back}>
        <Back to={routes.bypassedSubscription(subId)} />
      </div>
      <h1>
        Add Data
        <img src={add_data} alt="" />
      </h1>
      <DataRemaining subId={subId} />
      <AddDataPicker bypassedSubId={subId} />
    </div>
  )
}

export default AddDataScreen;
